<template>
  <!-- 发布帖子 -->
  <el-dialog :title="$t('发布帖子')" width="879px" top="8vh" :visible.sync="isVisible" @close="closeModal">

    <el-form ref="ruleForm" :rules="rules" :model="form" label-width="auto">
      <el-form-item :label="$t('帖子标题')" class="red-box" prop="tp_title">
        <el-input v-model="form.tp_title" :placeholder="$t('请您在标题中简明提出问题')" name="tp_title"></el-input>
      </el-form-item>

      <el-form-item :label="$t('行业分类')" prop="tp_hy_dd_id">
        <el-select v-model="form.tp_hy_dd_id" :placeholder="$t('请选择行业')" name="tp_hy_dd_id">
          <el-option :label="item.label" :value="item.value" v-for="(item, index) in data.post_ins_list"
            :key="index"></el-option>

        </el-select>
      </el-form-item>
      <el-form-item :label="$t('场景分类')" prop="tp_cj_dd_id">
        <el-select v-model="form.tp_cj_dd_id" :placeholder="$t('请选择场景')" name="tp_cj_dd_id">
          <el-option :label="item.label" :value="item.value" v-for="(item, index) in data.post_scene_list"
            :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('帖子来源')">

        <el-select v-model="form.tp_source" :placeholder="$t('请选择来源')">
          <el-option :label="item.label" :value="item.value" v-for="(item, index) in data.post_source_list"
            :key="index"></el-option>
        </el-select>
      </el-form-item>

      <Editor v-model="form.tp_content" :height="300" :isUseOss="true" />

      <!-- 上传附件 -->

      <div class="mt-14">

        <Upload v-model="form.tp_annex" upType="FILEARR"
          :fileType='["mp3", "wav", "aac", "flac", "ogg", "mp4", "avi", "mkv", "mov", "wmv", "jpeg", "png", "gif", "bmp", "tiff", "pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "txt"]'
          :isUseOss="true" :key="componentKey" />
        <!-- <Upload v-model="form.tp_annex" upType="FILEARR" :isUseOss="true" /> -->
      </div>

      <div class="languige-text mt-8 harmonyos-text">
        {{ $t('发送语言版本') }}
        <el-tooltip :content="$t('可切换语言，在您的个人中心检查译文是否正确')" placement="top-start" effect="light">
          <span class="iconfont">&#xe677;</span>
        </el-tooltip>


        <el-checkbox-group v-model="form.other_lang" style="display: inline-block;" class="ml-23">
          <el-checkbox :label="langitem.tws_id" v-for="(langitem, langindex) in data.other_lang" :key="langindex">
            {{ $t(langitem.tws_name) }}
          </el-checkbox>
        </el-checkbox-group>





      </div>
      <!--  v-if="userinfo.user_expert == 10" -->
      <div class="languige-text harmonyos-text" v-if="userinfo.user_expert == 10">
        {{ $t('以实名身份发布') }}
        <el-tooltip :content="$t('以专家身份实名发布后文章页面会同步展示实名信息')" placement="bottom-start" effect="light">
          <span class="iconfont">&#xe677;</span>
        </el-tooltip>


        <el-checkbox-group v-model="form.is_expert" style="display: inline-block;" class="ml-23">
          <el-checkbox :key="10" :label="10">{{ $t('是') }}</el-checkbox>
        </el-checkbox-group>
        <!-- <el-checkbox v-model="form.is_expert" :key="10" label="是" class="ml-28"></el-checkbox> -->

      </div>


    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="closeModal" class="btn1">{{ $t('取消') }}</el-button>
      <el-button type="primary" class="btn2" @click="submitPost">{{ $t('发布') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import TinyMCEEditor from '../components/Tinymce/index.vue';
import Editor from '../components/Editor/index.vue';
import Upload from "@/components/Upload/index";
import { getMyInfo } from "@api/home";


export default {
  components: {
    TinyMCEEditor, Editor, Upload
  },
  props: {
    data: {
      type: Object, // 指定参数类型
      required: true // 是否为必需参数
    }
  },
  data() {
    return {
      isVisible: false,
      postContent: '',
      userinfo: [],
      form: {
        tp_title: "",
        tp_hy_dd_id: "",
        tp_cj_dd_id: "",
        tp_source: 10,
        tp_content: '',
        tp_annex: '',//附件
        other_lang: [],
        is_expert: [10],
        user_expert: 20,
      },

      rules: {
        tp_title: [
          { required: true, message: this.$t('请填写正确的文章标题'), trigger: 'blur' }
        ],
        tp_hy_dd_id: [
          { required: true, message: this.$t('请选择行业'), trigger: 'change' }
        ],
        tp_cj_dd_id: [
          { required: true, message: this.$t('请选择场景'), trigger: 'change' }
        ],

      },

      componentKey: 1,
    };
  },
  watch: {
    data: function(newData) {
      this.form.other_lang = newData.other_lang.map((lang) => lang.tws_id)
    }
  },
  mounted() {
    this.getCurrUserData();
  },
  methods: {
    // handleCheckboxChange(checked) {
    //   // 当复选框状态改变时，更新 is_expert 的值
    //   this.form.is_expert = checked ? 10 : 20;
    // },
    async getCurrUserData() {
      let res = await getMyInfo();
      if (res.status == 200) {
        this.userinfo = res.data;
      }
    },
    openModal() {
      this.isVisible = true;
      this.componentKey = 1;
    },
    closeModal() {
      this.isVisible = false;
      this.$refs['ruleForm'].clearValidate();
      this.$refs['ruleForm'].resetFields();

      setTimeout(() => {
        this.componentKey = 2;
        this.form = {
          tp_title: "",
          tp_hy_dd_id: "",
          tp_cj_dd_id: "",
          tp_source: 10,
          tp_content: '',
          tp_annex: '',//附件
          other_lang: this.data.other_lang.map((lang) => lang.tws_id),
          is_expert: [10]
        }
      }, 200);

    },
    submitPost() {

      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (this.form.tp_content.trim()) {
            if (this.userinfo.user_expert == 20) this.form.is_expert[0] = 20;
            this.form.is_expert = this.form.is_expert.length > 0 ? this.form.is_expert[0] : '';
            this.$emit('post-submitted', this.form);
            setTimeout(() => {
              this.closeModal();
            }, 20);

            var _this = this;
            setTimeout(() => {
              _this.form = {
                tp_title: "",
                tp_hy_dd_id: "",
                tp_cj_dd_id: "",
                tp_source: 10,
                tp_content: '',
                tp_annex: '',//附件
                other_lang: [],
                is_expert: [10]
              }
            }, 500);
          } else {
            this.$message.error(this.$t('请填写正确的帖子-详情'));
          }
        } else {
          const firstErrorField = this.$refs.ruleForm.fields.find(field => field.validateState === 'error');
          const errorElement = document.getElementsByName(firstErrorField.prop)[0];
          if (errorElement) {
            errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }



      })


    }
  }
};
</script>

<style scoped lang="scss">
.languige-text {
  font-size: 14px;
  font-weight: 400;
  color: rgb(25, 25, 25);
  line-height: 24px;
  margin-top: 4px;

  ::v-deep() {
    .el-checkbox__label {
      font-family: "harmonyos";
      color: #191919;
    }
  }
}

::v-deep() {
  .el-select {
    width: 100%;
  }

  .el-form-item__label:before {
    color: transparent !important;
  }

  .el-input__inner {
    height: 52px;
    padding-left: 23px;
    border: none;
    font-size: 14px;
    background-color: transparent;
    color: #949494;

    &::placeholder {
      color: #949494;
    }
  }

  .el-form-item__label {
    padding: 0 18px 0 0;
    position: relative;

    &::after {
      content: "";
      display: block;
      height: 14px;
      width: 1px;
      background-color: #CEC7C6;
      position: absolute;
      right: 0;
      top: 20px;
    }
  }

  .el-form-item__label-wrap .el-form-item__label {
    line-height: 52px;
    color: #423735;
    font-size: 14px;
  }

  .el-form-item {
    height: 54px;
    background-color: #F8F8F8;
    padding: 1px 22px;
    border-radius: 4px;
    margin-bottom: 20px;
    border-radius: 5px;
    border: 1px solid #F2F1F1;
  }

  .el-form-item.red-box {
    background-color: #FDF3F2;
  }

  .el-dialog__headerbtn {
    display: none;

  }

  .el-dialog__header {
    padding: 28px 32px 0px;
  }

  .el-dialog {

    max-height: 82vh;
    border-radius: 12px;
    // transform: translateY(-50%);
    // top: 50%;
  }

  .mce-flow-layout {
    background-color: #FDF3F2;
  }

  .mce-panel {
    border: 0 solid #e2e1e1;
    border-radius: 6px;
    overflow: hidden;
    box-shadow: none;
  }

  .mce-btn {
    background-color: transparent;
  }

  .el-dialog__body {
    margin-top: 20px;
    width: calc(100% - 24px);
    padding: 0px 12px 0 36px;
    max-height: calc(82vh - 180px);
    overflow: hidden;
    overflow-y: scroll;

    &::-webkit-scrollbar {
      width: 6px;
      height: 4px;
      background: transparent;
      border-radius: 8px;
    }

    &::-webkit-scrollbar-thumb {
      background: #CF4325;
      border-radius: 8px;
    }
  }

  .el-dialog__footer {
    padding: 26px 36px 26px;
  }

  .dialog-footer {

    .btn1,
    .btn2 {
      min-width: 76px;
      height: 36px;
      border-radius: 30px;
      padding: 0 16px;
      font-size: 14px;
    }

    .btn1 {
      background-color: #ffffff;
      border: 1px solid #ededed;

      &:hover {
        border: 1px solid #d9462f;
      }
    }

    .btn2 {
      // background-color: #D64F31;
      background: linear-gradient(to right, #eb6f54, #d9462f);
      border: none;

      &:hover {
        background: linear-gradient(to right, #d9462f, #d9462f);
      }
    }
  }

  .el-button+.el-button {
    margin-left: 24px;
  }
}
</style>